import { useEffect } from 'react';
import { useRoute } from 'components/router/Routing';
import { classNames, useQuery } from 'libs/react';
import { useState } from 'libs/react';
import { CreationMenu } from 'components/CreationMenu';
import { SidePanelStack } from 'components/sidePanel/SidePanelStack';
import { React } from 'libs/react';
import { ClientQuery } from 'graphql/Client/queries/ClientQuery';
import { useParams } from 'react-router-dom';
import { CreateContactPanel } from '../panels/CreateContactPanel';
import { useTranslation } from 'components/translation/TranslationProvider';
/**
 * @component ContactQuickAddMenu
 * @since 1.0.0
 */
export function ContactQuickAddMenu(props) {
    const { style, open, hideButton, buttonLabel, isEndClient, redirect } = Object.assign({ style: 'normal', redirect: false }, props);
    const route = useRoute();
    const { customLabels, language } = useTranslation();
    const [title, setTitle] = useState('');
    const [picto, setPicto] = useState('');
    const [navigationStack, setNavigationStack] = useState([]);
    const { id } = useParams();
    const [data] = useQuery(ClientQuery, {
        variables: {
            input: {
                id
            }
        },
        skip: !id
    });
    /**
     * @function onOpen
     * @since 1.0.0
     * @hidden
     */
    const onOpen = () => {
        pushPanel('create-contact');
    };
    useEffect(() => {
        if (open) {
            onOpen();
        }
    }, [open]);
    /**
     * @function onBack
     * @since 1.0.0
     * @hidden
     */
    const onBack = () => {
        if (navigationStack.length == 0) {
            return;
        }
        navigationStack.pop();
        setNavigationStack(navigationStack.slice());
    };
    /**
     * @function pushPanel
     * @since 1.0.0
     * @hidden
     */
    const pushPanel = (destination) => {
        const panelIndex = PanelInfos.findIndex((info) => info.index == destination);
        const infos = PanelInfos.find((info) => info.index == destination);
        if (!infos || panelIndex < 0) {
            return;
        }
        navigationStack.push({
            index: panelIndex + 1,
            item: Object.assign(Object.assign({}, infos), { title: isEndClient
                    ? customLabels['Contact'][language]
                    : customLabels['Representative'][language] })
        });
        setNavigationStack(navigationStack.slice());
    };
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    const onClose = () => {
        var _a;
        setNavigationStack([]);
        (_a = props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
    };
    /**
     * @function onContactCreateDone
     * @since 1.0.0
     * @hidden
     */
    const onContactCreateDone = (contact) => {
        onClose();
        if (!redirect) {
            props.onContactCreateDone && props.onContactCreateDone(contact);
        }
        else {
            route.replace({ name: 'contact.update', data: { id: contact.id } });
        }
    };
    useEffect(() => {
        var _a, _b;
        const lastItem = navigationStack.length > 0
            ? navigationStack[navigationStack.length - 1]
            : null;
        setTitle((_a = lastItem === null || lastItem === void 0 ? void 0 : lastItem.item.title) !== null && _a !== void 0 ? _a : '');
        setPicto((_b = lastItem === null || lastItem === void 0 ? void 0 : lastItem.item.picto) !== null && _b !== void 0 ? _b : '');
    }, [navigationStack]);
    const className = classNames('quick-add-panel-stack', 'quick-add-panel-stack--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(CreationMenu, { active: navigationStack.length > 0, onOpen: onOpen, hideButton: hideButton, buttonWithLabel: true, label: buttonLabel },
            React.createElement(SidePanelStack, { active: navigationStack.length > 0, activeIndex: navigationStack.length > 0
                    ? navigationStack[navigationStack.length - 1].index
                    : 0, onBack: onBack, title: title, picto: picto, onClose: onClose },
                React.createElement(CreateContactPanel, { onDone: onContactCreateDone, defaultOrganizationValue: data === null || data === void 0 ? void 0 : data.client, isEndClient: isEndClient })))));
}
/**
 * @const PanelInfos
 * @since 1.0.0
 */
export const PanelInfos = [
    {
        index: 'create-contact',
        title: t('Contact')
    }
];
